import React from "react";
import { Modal, ModalBody, Button, Form, FormGroup, Input, Spinner } from "reactstrap";
import { LogIn } from "react-feather";

const brandNavy = "#344e66";

const LoginModal = ({
  toggleLogin,
  setToggleLogin,
  branch,
  setBranch,
  username,
  setUserName,
  password,
  setPassword,
  selectedRoute,
  setSelectedRoute,
  handleSubmit,
  loading,
}) => {
  return (
    <Modal
      isOpen={toggleLogin}
      toggle={() => setToggleLogin(!toggleLogin)}
      centered
      className="border-0 shadow-lg"
    >
      <ModalBody className="p-5">
        <h4 className="fw-bold mb-4" style={{ color: brandNavy, letterSpacing: "0.05em", textTransform: "uppercase" }}>
          Secure Authentication
        </h4>
        
        <Form onSubmit={handleSubmit}>
          {["branch", "username", "password"].map((field) => (
            <FormGroup className="mb-3" key={field}>
              <Input
                type={field === "password" ? "password" : "text"}
                placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
                value={field === "branch" ? branch : field === "username" ? username : password}
                onChange={(e) => {
                  if (field === "branch") setBranch(e.target.value);
                  if (field === "username") setUserName(e.target.value);
                  if (field === "password") setPassword(e.target.value);
                }}
                className="rounded-0 border-top-0 border-start-0 border-end-0 shadow-none"
                style={{ borderBottom: `2px solid #ddd` }}
                required
              />
            </FormGroup>
          ))}

          <FormGroup className="mb-4">
            <Input
              type="select"
              value={selectedRoute}
              onChange={(e) => setSelectedRoute(e.target.value)}
              className="rounded-0 shadow-none border-bottom"
              style={{ border: "none", borderBottom: "2px solid #ddd" }}
            >
              <option value="">Select Department</option>
              <option value="feed">Feedback</option>
              <option value="que">Que Management</option>
            </Input>
          </FormGroup>

          {loading ? (
            <div className="text-center py-2">
              <Spinner size="sm" style={{ color: brandNavy }} />
            </div>
          ) : (
            <Button
              block
              type="submit"
              className="rounded-0 py-2 border-0 fw-bold"
              style={{ backgroundColor: brandNavy, letterSpacing: "0.05em" }}
            >
              <LogIn size={16} className="me-2" />
              AUTHENTICATE
            </Button>
          )}
        </Form>
        
        <div className="text-center mt-3">
          <button 
            className="btn btn-link text-secondary text-decoration-none small" 
            onClick={() => setToggleLogin(false)}
          >
            Cancel Access
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default LoginModal;